import React, { useEffect, useRef, useState } from 'react';
import { useContextSelector } from 'use-context-selector';

import styles from './Main.module.scss';
import Slide from '../Content/Slide/Slide';
import VideoYoutube from '../Content/VideoYoutube/VideoYoutube';
import Quiz from '../Content/Quiz/Quiz';
import VideoHtml from '../Content/VideoHtml/VideoHtml';
import Game from '../Content/Game/Game';
import { UIContext } from '../context/UI/UIContext';
import Agreement from '../Content/Agreement/Agreement';
import Certificate from '../Content/Certificate/Certificate';
import VideoVimeo from '../Content/VideoVimeo/VideoVimeo';

function Main({ globalState }) {
  const { getCurrentPage, course } = globalState;
  const page = getCurrentPage();
  const [isChangingPage, setIsChangingPage] = useState(false);
  const timeout = useRef();
  const background = useContextSelector(UIContext, (c) => c.background);

  useEffect(() => {
    if (!isChangingPage) return;
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => setIsChangingPage(false), 50);
  }, [isChangingPage]);

  useEffect(() => {
    setIsChangingPage(true);
  }, [page.resourceId]);

  // onUnmount: clear timeout to avoid render errors
  useEffect(() => {
    return () => clearTimeout(timeout.current);
  }, []);

  function renderPage() {
    switch (page?.resourceType) {
      case 'slide':
        return (
          <Slide
            filename={page?.filename}
            baseURL={course.baseURL}
            hyperlink={page?.hyperlink}
            globalState={globalState}
          />
        );
      case 'video':
        if (page?.video?.type === 'youtube') {
          return (
            <VideoYoutube
              {...page}
              url={page.video.youtubeUrl}
              globalState={globalState}
            />
          );
        } else if (page?.video?.type === 'vimeo') {
          return (
            <VideoVimeo
              {...page}
              url={page.video.vimeoUrl}
              globalState={globalState}
            />
          );
        } else if (page?.video?.type === 'upload') {
          return (
            <VideoHtml
              {...page}
              baseURL={course.baseURL}
              globalState={globalState}
            />
          );
        } else {
          return null;
        }
      case 'quiz':
        return <Quiz {...page} globalState={globalState} />;
      case 'game':
        return <Game {...page} globalState={globalState} />;
      case 'agreement':
        return <Agreement {...page} globalState={globalState} />;
      case 'certificate':
        return <Certificate {...page} globalState={globalState} />;
      default:
        return <span>{page?.type}</span>;
    }
  }

  if (isChangingPage) return null;

  const backgroundOpacity =
    background?.opacity >= 0 && background?.opacity <= 1
      ? 1 - background.opacity
      : 0;

  return (
    <div
      className={styles.Main}
      style={{
        backgroundImage:
          background?.image?.name && course?.baseURL
            ? `linear-gradient(rgba(255, 255, 255, ${backgroundOpacity}), rgba(255, 255, 255, ${backgroundOpacity})), url('${course?.baseURL}/${background?.image?.name}')`
            : // example on how to darken a background-image (because opacity does not work)
              // `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('${course?.baseURL}/${background?.image?.name}')`
              undefined,
      }}
    >
      {renderPage()}
    </div>
  );
}

export default Main;
